// components/InitialLoader.js
import React from 'react';
import './InitialLoader.css'; // gunakan untuk styling tambahan jika perlu

const InitialLoader = () => {
  return (
    <div style={styles.container}>
      <div style={styles.spinner}></div>
      <p style={styles.text}>Memuat data awal...</p>
    </div>
  );
};

const styles = {
  container: {
    height: '100vh',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    backgroundColor: '#f9fafb',
  },
  spinner: {
    width: '48px',
    height: '48px',
    border: '6px solid #e5e7eb',
    borderTop: '6px solid #31647C',
    borderRadius: '50%',
    animation: 'spin 1s linear infinite',
  },
  text: {
    marginTop: '16px',
    color: '#6b7280',
    fontSize: '16px',
    fontWeight: '500',
    fontFamily: 'sans-serif',
  },
};

export default InitialLoader;
